import { values } from "draft-js/lib/DefaultDraftBlockRenderMap";

export const convertToSlug = str => {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();

    // remove accents, swap ñ for n, etc
    var from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
    var to   = "aaaaaeeeeeiiiiooooouuuunc------";
    for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-'); // collapse dashes

    return str;
}

export const convertToCnpj = str => {
    return str
        .replace(/\D+/g, '')
        .replace(/(\d{2})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1/$2')
        .replace(/(\d{4})(\d)/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1');
}

export const convertToCpf = str => {
    return str
        .replace(/\D+/g, '')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1');
}

export const convertToCep = str => {
    return str
        .replace(/\D+/g, '')
        .replace(/(\d{5})(\d)/, '$1-$2')
        .replace(/(-\d{3})\d+?$/, '$1');
}

export const convertToCellphone = str => {
    return convertToPhone(str);
    // return str
    //     .replace(/\D/g, '')
    //     .replace(/\D/g, '')
    //     .replace(/(\d{1})(\d)/, '($1$2')
    //     .replace(/(\d{2})(\d)/, '$1) $2')
    //     .replace( /(\d{5})(\d)/, '$1-$2')
    //     .replace(/(-\d{4})\d+?$/, '$1');
}

export const convertToPhone = str => {
    // Remove tudo que não é dígito
    const cleaned = str.replace(/\D/g, '');

    // Aplica a máscara com base no tamanho do número limpo
    if (cleaned.length >= 11) {
        // Máscara completa para 11 dígitos: (XX) XXXXX-XXXX
        return cleaned
        .replace(/(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{5})(\d)/, '$1-$2')
        .replace(/(-\d{4})\d+?$/, '$1');
    } else if (cleaned.length >= 6) {
        // Máscara para 6 a 10 dígitos: (XX) XXXX-XXXX
        return cleaned
        .replace(/(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{4})(\d)/, '$1-$2');
    } else if (cleaned.length >= 3) {
        // Máscara para 3 a 5 dígitos: (XX) XXX
        return cleaned.replace(/(\d{2})(\d)/, '($1) $2');
    } else if (cleaned.length >= 1) {
        // Máscara para 1 a 2 dígitos: (XX
        return cleaned.replace(/(\d{1,2})/, '($1');
    }

    // Retorna vazio se não houver dígitos
    return cleaned;
}

export const convertToMoney = str => {
    let v = str.replace(/\D/g,'');
	v = (v/100).toFixed(2) + '';
	v = v.replace(".", ",");
	v = v.replace(/(\d)(\d{3})(\d{3}),/g, "$1.$2.$3,");
	v = v.replace(/(\d)(\d{3}),/g, "$1.$2,");
	return `R$ ${v}`;
}

export const convertToPercentage = str => {
    let v = str.replace(/\D/g,'');
	v = (v/10000).toFixed(4) + '';
    v = v.replace(".", ",");
	return `${v} %`;
}

export const convertToInt = str => {
    let v = str.replace(/\D/g,'');
    v = parseInt(v);
    v = isNaN(v) ? 0 : v;
    return v;
}

